"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createContext;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Create context helper that provides a context accessor function
 *
 * @param {string} rootComponentName component name used in errors if context used outside of provider
 * @param {React.ContextType} defaultContext context used as a fallback
 * @returns {[function,function]} Provider and context accessor functions
 */
function createContext(rootComponentName, defaultContext) {
  const Ctx = /*#__PURE__*/_react.default.createContext(defaultContext);
  function Provider(props) {
    const {
        children
      } = props,
      context = (0, _objectWithoutProperties2.default)(props, _excluded);
    const value = (0, _react.useMemo)(() => context,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(context));
    return /*#__PURE__*/_react.default.createElement(Ctx.Provider, {
      value: value
    }, children);
  }
  Provider.propTypes = {
    children: _propTypes.default.node.isRequired
  };
  function useContext(callerComponentName) {
    const context = _react.default.useContext(Ctx);
    if (context) {
      return context;
    }
    if (defaultContext) {
      return defaultContext;
    }
    throw Error(`${callerComponentName} must be rendered inside of a ${rootComponentName} component.`);
  }
  Ctx.displayName = `${rootComponentName}Context`;
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext];
}